import styles from '../index.module.less';

import { Card, Col, Helmet, Logo, Row } from '$HVUI';

const Index = () => {
    return (
        <section className={styles['wrapper']}>
            <Helmet>
                <title>Token View</title>
            </Helmet>
            <main>
                <Card
                    size="small"
                    className={styles['card']}
                    title={
                        <Row>
                            <Col xs={20} sm={12} md={6} style={{ padding: 0 }}>
                                <Logo style={{ width: '100%' }} />
                            </Col>
                        </Row>
                    }
                >
                    <Row
                        gutter={[12, 24]}
                        align="middle"
                        justify="center"
                        style={{ marginTop: '1em' }}
                    >
                        <Col className={styles['error-message']}>
                            <p>Sorry, something went wrong.</p>
                            <p>
                                Please use our{' '}
                                <a href="https://healthvana.com/contact/">
                                    contact form
                                </a>{' '}
                                to reach out for help.
                            </p>
                            <p lang="es">Disculpe, algo salió mal.</p>
                            <p lang="es">
                                Por favor utilice nuestro{' '}
                                <a href="https://healthvana.com/contact/">
                                    impreso de contacto
                                </a>{' '}
                                para buscar ayuda.
                            </p>
                        </Col>
                    </Row>
                </Card>
            </main>
        </section>
    );
};

export default Index;
